import { render } from "./FactorCard.vue?vue&type=template&id=176802bb&scoped=true"
import script from "./FactorCard.vue?vue&type=script&lang=js"
export * from "./FactorCard.vue?vue&type=script&lang=js"

import "./FactorCard.vue?vue&type=style&index=0&id=176802bb&scoped=true&lang=css"

import exportComponent from "E:\\Proj\\Apps\\takht-jamshid\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-176802bb"]])

export default __exports__